import API from "../utils/api";


const createCategory = async (data) => {
  const response = await API.post("/api/categories", data);
  return response.data;
};

const getallCategories = async () => {
  console.log("Fetching categories with activeOnly:");
  const response = await API.get(`/api/categories`);
  return response.data;
};

const getSingleCategory = async (id) => {
  const response = await API.get(`/api/categories/${id}`);
  return response.data;
};

const updateCategory = async (id, data) => {
  const response = await API.put(`/api/categories/${id}`, data);
  return response.data;
};

const deleteCategory = async (id) => {
  const response = await API.delete(`/api/categories/${id}`);
  return response.data;
};

const activateCategory = async (id) => {
  const response = await API.put(`/api/categories/activate/${id}`);
  return response.data;
};


const categoryService = {
  createCategory,
  getallCategories,
  getSingleCategory,
  updateCategory,
  deleteCategory,
  activateCategory
};

export default categoryService;